/**
 * 工作流配置
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async setModel(keyId) {
		return request(api.workflow.WORK_FLOW_MANAGE + "/" + keyId + "/convertToModel", METHOD.GET);
	},

}

export default {dataApi}